import type { FormatResults, ResultImage, SourceImage } from "./imageTypes";

export const revokeUrl = (url?: string) => {
  if (url) URL.revokeObjectURL(url);
};

export const revokeSources = (items: SourceImage[]) => {
  items.forEach((item) => revokeUrl(item.url));
};

export const revokeResults = (results: FormatResults) => {
  Object.values(results).forEach((items) => {
    items.forEach((item) => {
      revokeUrl(item.url);
      revokeUrl(item.previewUrl);
    });
  });
};

export const revokeAnimationResults = (results: Record<string, ResultImage>) => {
  Object.values(results).forEach((item) => {
    revokeUrl(item.url);
    revokeUrl(item.previewUrl);
  });
};
